var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCableTelevisionOutlet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.86,9.32 7.36,9.32 7.36,4.38 1.46,4.38 1.46,3.88 7.86,3.88  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "10.03,11.61 9.53,11.61 9.53,9.4 5.66,9.4 5.66,11.61 5.16,11.61 5.16,8.9 10.03,8.9  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.42,8V5.21H9.38V4.84h2.51v0.37h-1.05V8H10.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.58,8l-1.22-3.16h0.45l0.82,2.3c0.07,0.18,0.12,0.36,0.17,0.52c0.05-0.17,0.11-0.35,0.17-0.52l0.85-2.3 h0.43L14.01,8H13.58z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCableTelevisionOutlet);
export default __webpack_public_path__ + "static/media/CableTelevisionOutlet.12c3df656306b59237b3eb92f22d01ed.svg";
export { ForwardRef as ReactComponent };